import { PSP } from 'app/typings/PSP';

export function isProvider(maybeProvider: string): maybeProvider is PSP {
  return [PSP.Adyen, PSP.Stripe, PSP.StripeIssuing].some(
    (e) => e === maybeProvider
  );
}
